module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-bold-rounded-MQNABNC6.woff2?f1fa27ef1cfbccecbdcfe4c6d4ce5929";